import type { FunctionComponent } from "react"

import CommentsSection from "@/components/Comment/CommentsSection"
import type { Comment } from "@/graphql/codegen/graphql"
import { CommentParentTableType } from "@/graphql/codegen/graphql"

interface CommentProps extends Comment {
  companyId: string
}

const CompanyComments: FunctionComponent<CommentProps> = ({ companyId }) => {
  return <CommentsSection type={CommentParentTableType.Company} referenceId={companyId} />
}

export default CompanyComments
